import { pathJoin } from '../../../../routing/utils';

// Pure path map — no component imports, safe in the eager route-map graph.
// The route CONFIG (which imports the page components) stays in
// ./route-config and is only loaded with the lazy section shell.
// `pools/:poolId` is the shared-pool detail (folded in from the retired
// standalone Pools section — the pools list is now a section on the
// Agreements page itself).
export const createRoutesMap = (prefix: string) => ({
  ':ticketId': (containerId: string) => pathJoin(prefix)(containerId).chain,
  'pools/:poolId': (poolId = ':poolId') =>
    pathJoin(prefix)('pools')(poolId).chain,
});
